<app-common-dialog-wrapper
  [headerText]="'Edit member'"
  [confirmButton]="submitButton"
  [cancelButton]="cancelButton"
  (onDialogClose)="onDialogClose($event)"
  [showTopCloseButton]="false"
>
  <mat-dialog-content class="dialog-content">
    <section
      class="section"
      mdsInlineFormSchema
      [schema]="schema"
      [lines]="lines"
      (openMenuItem)="openMenuItem($event)"
      (formValueChanged)="formValueChanged($event)"
      style="width: 98%"
    ></section>
    <mds-button class="remove-btn" [type]="'warn'" [size]="'medium'" (click)="removeFromTeam()">
      Remove from team
    </mds-button>
  </mat-dialog-content>
</app-common-dialog-wrapper>
